function getLocalizedUrl(path) {
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  return root.replace(/\/$/, '') + '/' + path.replace(/^\//, '');
}

document.addEventListener("DOMContentLoaded", function () {
  // Store references to our event listeners
  const eventListeners = {
    quantityUp: null,
    quantityDown: null,
    quantityInput: null,
    removeItem: null,
    quickAdd: null,
    checkout: null,
  };

  let isQuickAdding = false;

  // Initialize cart drawer
  initializeCartDrawer();

  // When user clicks browser back (or tab becomes visible), refresh cart so drawer shows latest content
  let lastCartRefreshAt = 0;
  const CART_REFRESH_THROTTLE_MS = 2000;
  function refreshCartWhenPageShown() {
    const now = Date.now();
    if (now - lastCartRefreshAt < CART_REFRESH_THROTTLE_MS) return;
    lastCartRefreshAt = now;
    refreshCartContent();
  }
  // Run on every pageshow: back button (bfcache or reload) and initial load. Throttle avoids duplicate work.
  window.addEventListener("pageshow", refreshCartWhenPageShown);
  document.addEventListener("visibilitychange", function () {
    if (document.visibilityState === "visible") refreshCartWhenPageShown();
  });

  // Subscribe to cart updates if available
  if (typeof subscribe === "function") {
    subscribe(PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
    subscribe(PUB_SUB_EVENTS.cartError, handleCartError);
  }

  function initializeCartDrawer() {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer) return;

    // Remove previous listeners if they exist
    if (eventListeners.quantityUp) {
      document.removeEventListener("click", eventListeners.quantityUp);
    }
    if (eventListeners.quantityDown) {
      document.removeEventListener("click", eventListeners.quantityDown);
    }
    if (eventListeners.quantityInput) {
      document.removeEventListener("input", eventListeners.quantityInput);
    }
    if (eventListeners.removeItem) {
      cartDrawer.removeEventListener("click", eventListeners.removeItem);
    }
    if (eventListeners.quickAdd) {
      cartDrawer.removeEventListener("submit", eventListeners.quickAdd);
    }
    if (eventListeners.quickAddTouch) {
      cartDrawer.removeEventListener("touchend", eventListeners.quickAddTouch);
    }
    if (eventListeners.checkout) {
      cartDrawer.removeEventListener("click", eventListeners.checkout);
    }

    // Open Cart triggers (these don't need cleanup as they're on static elements)
    document.querySelectorAll("[data-open-cart]").forEach((button) => {
      button.addEventListener("click", openCartDrawer);
    });

    // Close Cart handler
    document.addEventListener("click", (e) => {
      if (e.target.closest(".cart-drawer__close")) {
        closeCartDrawer();
      }
    });

    // Store and setup new event listeners
    eventListeners.removeItem = (e) => {
      if (e.target.closest("[data-remove-item]")) {
        e.preventDefault();
        handleRemoveItem(e.target.closest("[data-remove-item]"));
      }
    };
    cartDrawer.addEventListener("click", eventListeners.removeItem);

    // Checkout: one click → one batch update (add 1 to first line per 2x variant with odd total) → redirect
    eventListeners.checkout = (e) => {
      if (e.target.closest("[data-cart-checkout]")) {
        e.preventDefault();
        ensureBogoEvenThenCheckout();
      }
    };
    cartDrawer.addEventListener("click", eventListeners.checkout);

    // Initialize quantity controls with proper debouncing
    initQuantityControls();

    // Quick add form handling - SUBMIT event
    eventListeners.quickAdd = async (e) => {
      if (e.target.closest("form[action='/cart/add']")) {
        e.preventDefault();
        const form = e.target.closest("form");
        await handleQuickAdd(form);
      }
    };
    cartDrawer.addEventListener("submit", eventListeners.quickAdd);

    // Quick add form handling - TOUCH event for mobile
    eventListeners.quickAddTouch = async (e) => {
      // Check if the touch target is a quick-add button or inside one
      const quickAddBtn = e.target.closest(".quick-add-btn");
      if (quickAddBtn) {
        e.preventDefault();
        e.stopPropagation();

        const form = quickAddBtn.closest("form");
        if (form) {
          await handleQuickAdd(form);
        }
      }
    };

    // Add touch event listener to the cart drawer
    cartDrawer.addEventListener("touchend", eventListeners.quickAddTouch, {
      passive: false,
    });

    // Also add click event to quick add buttons as a fallback
    cartDrawer.querySelectorAll(".quick-add-btn").forEach((button) => {
      button.addEventListener("click", (e) => {
        e.preventDefault();
        const form = button.closest("form");
        if (form) {
          handleQuickAdd(form);
        }
      });
    });

    // Initialize slider if present
    const slider = cartDrawer.querySelector(".featured-slider");
    if (slider && window.initFeaturedSlider) {
      window.initFeaturedSlider(slider);
    }
  }

  async function handleCartUpdate(data) {
    if (data.action === "add") {
      await refreshCartContent(data.variant);
      openCartDrawer();
    }
  }

  // Global variable to track pending quantity updates
  let pendingQuantityUpdate = null;

  // Store pending timeouts for each cart item (key = itemKey, value = timeout ID)
  const pendingTimeouts = new Map();

  function initQuantityControls() {
    // Remove previous listeners if they exist
    if (eventListeners.quantityUp) {
      document.removeEventListener("click", eventListeners.quantityUp);
    }
    if (eventListeners.quantityDown) {
      document.removeEventListener("click", eventListeners.quantityDown);
    }
    if (eventListeners.quantityInput) {
      document.removeEventListener("input", eventListeners.quantityInput);
    }

    // Quantity up handler with debouncing
    eventListeners.quantityUp = (e) => {
      if (e.target.closest("[data-quantity-up]")) {
        e.preventDefault();
        const button = e.target.closest("[data-quantity-up]");
        const quantityControl = button.closest(".cart-item");
        const input = quantityControl.querySelector("[data-quantity-input]");
        const itemKey = quantityControl.dataset.itemId;
        const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);

        // Update input value immediately for visual feedback
        let newQuantity = parseInt(input.value) + 1;

        // Validate against stock
        if (maxQuantity > 0 && newQuantity > maxQuantity) {
          showStockError(quantityControl, `Only ${maxQuantity} available`);
          newQuantity = maxQuantity;
        }

        input.value = newQuantity;
        input.classList.add("updating");
        updateCartDrawerBusyState();

        // Clear any existing timeout for this item
        if (pendingTimeouts.has(itemKey)) {
          clearTimeout(pendingTimeouts.get(itemKey));
        }

        // Set new timeout to actually update the cart
        const timeoutId = setTimeout(async () => {
          pendingTimeouts.delete(itemKey);
          quantityControl.classList.add("updating");
          updateCartDrawerBusyState();
          try {
            await handleQuantityChange(button, 0);
          } finally {
            quantityControl.classList.remove("updating");
            input.classList.remove("updating");
            updateCartDrawerBusyState();
          }
        }, 500); // 500ms delay

        pendingTimeouts.set(itemKey, timeoutId);
      }
    };
    document.addEventListener("click", eventListeners.quantityUp);

    // Quantity down handler with debouncing
    eventListeners.quantityDown = (e) => {
      if (e.target.closest("[data-quantity-down]")) {
        e.preventDefault();
        const button = e.target.closest("[data-quantity-down]");
        const quantityControl = button.closest(".cart-item");
        const input = quantityControl.querySelector("[data-quantity-input]");
        const itemKey = quantityControl.dataset.itemId;

        // BOGO: will rebalance in handleQuantityChange (reduce total by 2, split)
        if (quantityControl.dataset.bogo === "true") {
          quantityControl.dataset.bogoDown = "true";
        }

        // Update input value immediately for visual feedback
        let newQuantity = parseInt(input.value) - 1;
        if (newQuantity < 1) newQuantity = 1;

        input.value = newQuantity;
        input.classList.add("updating");
        updateCartDrawerBusyState();

        // Clear any existing timeout for this item
        if (pendingTimeouts.has(itemKey)) {
          clearTimeout(pendingTimeouts.get(itemKey));
        }

        // Set new timeout to actually update the cart
        const timeoutId = setTimeout(async () => {
          pendingTimeouts.delete(itemKey);
          quantityControl.classList.add("updating");
          updateCartDrawerBusyState();
          try {
            await handleQuantityChange(button, 0);
          } finally {
            quantityControl.classList.remove("updating");
            input.classList.remove("updating");
            updateCartDrawerBusyState();
          }
        }, 500); // 500ms delay

        pendingTimeouts.set(itemKey, timeoutId);
      }
    };
    document.addEventListener("click", eventListeners.quantityDown);

    // Input handler with proper debouncing
    eventListeners.quantityInput = debounce(async (e) => {
      if (e.target.matches("[data-quantity-input]")) {
        const input = e.target;
        const quantityControl = input.closest(".cart-item");
        const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);
        let newQuantity = parseInt(input.value) || 1;

        if (maxQuantity > 0 && newQuantity > maxQuantity) {
          showStockError(quantityControl, `Only ${maxQuantity} available`);
          newQuantity = maxQuantity;
        }

        if (pendingQuantityUpdate) return;
        pendingQuantityUpdate = true;
        try {
          await handleQuantityChange(input, 0);
        } finally {
          pendingQuantityUpdate = false;
        }
      }
    }, 750);
    document.addEventListener("input", eventListeners.quantityInput);
  }

  function showStockError(element, message) {
    // Remove existing error if any
    const existingError = element.querySelector(".stock-error");

    existingError.textContent = message;
    // Auto-remove after 3 seconds
    setTimeout(() => {
      existingError.textContent = "";
    }, 3000);
  }

  function updateCartDrawerBusyState() {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer) return;
    const hasBusy = cartDrawer.querySelector(".cart-item.updating, .cart-item.removing");
    cartDrawer.classList.toggle("cart-drawer--busy", !!hasBusy);
  }

  /** Get all BOGO line items for a variant (original + discounted rows). */
  function getBogoLineItems(variantId) {
    const cartDrawer = document.getElementById("cart-drawer");
    if (!cartDrawer) return [];
    return Array.from(
      cartDrawer.querySelectorAll(
        `.cart-item[data-bogo="true"][data-variant-id="${variantId}"]`
      )
    ).map((el) => {
      const input = el.querySelector("[data-quantity-input]");
      return {
        key: el.dataset.itemId,
        el,
        qty: parseInt(input?.value, 10) || 0,
      };
    });
  }

  /** Build updates object to set each BOGO line to a share of newTotal (even split). */
  function splitBogoUpdates(items, newTotal) {
    const updates = {};
    const n = items.length;
    if (n === 0) return updates;
    let remaining = Math.max(0, newTotal);
    items.forEach((item, i) => {
      const part =
        i === n - 1 ? remaining : Math.ceil(remaining / (n - i));
      updates[item.key] = part;
      remaining -= part;
    });
    return updates;
  }

  /** Checkout: just go to checkout (no adding 1; quantities are kept even by up/down/remove). */
  async function ensureBogoEvenThenCheckout() {
    window.location.href = getLocalizedUrl('/checkout');
  }

  function handleCartError(error) {
    console.error("Cart Error:", error);
    // Show error UI
    const errorElement = document.createElement("div");
    errorElement.className = "cart-error";
    errorElement.textContent = error.error || "Cart operation failed";
    document.getElementById("cart-drawer").prepend(errorElement);
    setTimeout(() => errorElement.remove(), 3000);
  }

  async function handleQuantityChange(element, change) {
    const quantityControl = element.closest(".cart-item");
    const input = quantityControl.querySelector("[data-quantity-input]");
    const itemKey = quantityControl.dataset.itemId;
    const variantId = quantityControl.dataset.variantId;
    const maxQuantity = parseInt(quantityControl.dataset.maxQuantity);
    const isBogo = quantityControl.dataset.bogo === "true";

    // BOGO: rebalance all lines for this variant (even split)
    if (isBogo && variantId) {
      const items = getBogoLineItems(variantId);
      if (items.length === 0) return;

      const isDown = quantityControl.dataset.bogoDown === "true";
      if (isDown) delete quantityControl.dataset.bogoDown;

      // Re-read qtys; use the current input.value for the line we're editing (so typed value is correct)
      const editedValue = parseInt(input.value, 10) || 0;
      items.forEach((it) => {
        if (it.el === quantityControl) {
          it.qty = editedValue;
        } else {
          const inp = it.el.querySelector("[data-quantity-input]");
          it.qty = parseInt(inp?.value, 10) || 0;
        }
      });
      const currentTotal = items.reduce((s, i) => s + i.qty, 0);
      let newTotal;

      if (isDown) {
        // Only when user clicked quantity-down: round down to even, min 2 (1 and 1)
        newTotal = currentTotal % 2 !== 0
          ? Math.max(2, currentTotal - 1)
          : Math.max(2, currentTotal - 2);
      } else {
        // Typed or quantity-up: round up to even (e.g. 1+4=5 → 6 → 3 and 3)
        newTotal = currentTotal % 2 !== 0 ? currentTotal + 1 : currentTotal;
      }

      const maxTotal = maxQuantity > 0 ? items.length * maxQuantity : 99999;
      newTotal = Math.min(newTotal, maxTotal);

      const updates = splitBogoUpdates(items, newTotal);
      quantityControl.classList.add("updating");
      updateCartDrawerBusyState();
      try {
        const response = await fetch(getLocalizedUrl('/cart/update.js'), {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ updates }),
        });
        const data = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(data.description || "Cart update failed");
        await refreshCartContent(data);
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartUpdate, { action: "update", cart: data });
        }
      } catch (err) {
        if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
          publish(PUB_SUB_EVENTS.cartError, { error: err.message, context: "update-quantity" });
        }
      } finally {
        quantityControl.classList.remove("updating");
        input.classList.remove("updating");
        updateCartDrawerBusyState();
      }
      return;
    }

    // Non-BOGO: single line update
    let newQuantity =
      change === 0 ? parseInt(input.value) || 1 : Number(input.value) + change;

    if (maxQuantity > 0 && newQuantity > maxQuantity) {
      showStockError(quantityControl, `Only ${maxQuantity} available`);
      newQuantity = maxQuantity;
    }
    if (newQuantity < 1) newQuantity = 1;

    input.value = newQuantity;
    quantityControl.classList.add("updating");

    try {
      const response = await fetch(getLocalizedUrl('/cart/change.js'), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: itemKey, quantity: newQuantity }),
      });
      const cartData = await response.json();
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { action: "update", itemKey, quantity: newQuantity, cart: cartData });
      }
      await refreshCartContent(cartData);
    } catch (error) {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartError, { error: error.message, context: "update-quantity" });
      }
      input.value = Number(input.value) - change;
    } finally {
      quantityControl.classList.remove("updating");
      updateCartDrawerBusyState();
    }
  }

  async function handleRemoveItem(button) {
    const itemElement = button.closest(".cart-item");
    const itemKey = itemElement.dataset.itemId;
    const variantId = itemElement.dataset.variantId;
    const isBogo = itemElement.dataset.bogo === "true";

    try {
      button.disabled = true;
      itemElement.classList.add("removing");
      updateCartDrawerBusyState();

      let updates;
      if (isBogo && variantId) {
        const bogoItems = getBogoLineItems(variantId);
        const currentTotal = bogoItems.reduce((s, i) => s + i.qty, 0);
        const newTotal = currentTotal >= 8 ? Math.max(0, currentTotal - 4) : Math.max(0, currentTotal - 2);
        if (newTotal === 0) {
          updates = {};
          bogoItems.forEach((it) => { updates[it.key] = 0; });
        } else {
          updates = splitBogoUpdates(bogoItems, newTotal);
        }
      } else {
        updates = { [itemKey]: 0 };
      }

      const response = await fetch(getLocalizedUrl('/cart/update.js'), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "XMLHttpRequest",
        },
        body: JSON.stringify({ updates }),
      });

      const cartData = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(cartData.description || "Remove failed");

      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartUpdate, { action: "remove", itemKey, cart: cartData });
      }
      await refreshCartContent(cartData);
    } catch (error) {
      if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
        publish(PUB_SUB_EVENTS.cartError, { error: error.message, context: "remove-item" });
      }
      button.disabled = false;
      itemElement.classList.remove("removing");
      updateCartDrawerBusyState();
    } finally {
      updateCartDrawerBusyState();
    }
  }

  async function refreshCartContent(cartData) {
    try {
      const cartDrawer = document.getElementById("cart-drawer");
      const cartContent = cartDrawer.querySelector(".cart-drawer__items");
      if (!cartContent) return;

      cartContent.classList.add("loading");

      const response = await fetch(getLocalizedUrl('/') + '?section_id=cart');
      if (!response.ok) throw new Error("Failed to fetch cart content");

      const text = await response.text();
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = text;

      // Get the new content from the response - use querySelector instead of getElementById
      const newCartDrawer = tempDiv.querySelector("#cart-drawer");
      if (!newCartDrawer) throw new Error("Cart drawer not found in response");

      // Replace the entire drawer content
      cartDrawer.innerHTML = newCartDrawer.innerHTML;

      // Clear busy state - new content has no updating/removing items
      cartDrawer.classList.remove("cart-drawer--busy");

      // Clear all pending timeouts since cart items changed
      pendingTimeouts.forEach((timeoutId) => clearTimeout(timeoutId));
      pendingTimeouts.clear();

      // Reinitialize the cart drawer completely
      initializeCartDrawer();

      // Update cart count
      const cartResponse = await fetch(getLocalizedUrl('/cart.js'));
      const updatedCartData = await cartResponse.json();

      document.querySelectorAll("[data-cart-count]").forEach((el) => {
        el.textContent = updatedCartData.item_count;
      });

      // Update shipping bar
      if (window.free_shipping_enabled) {
        updateShippingBar(updatedCartData);
      }
    } catch (error) {
      console.error("Error refreshing cart content:", error);
    } finally {
      const cartContent = document.querySelector(
        "#cart-drawer .cart-drawer__items"
      );
      if (cartContent) cartContent.classList.remove("loading");
    }
  }

  function updateShippingBar(cartData) {
    const freeShippingEnabled =
      document.querySelector(".free-shipping-bar")?.dataset
        .freeShippingEnabled === "true";

    if (!freeShippingEnabled) return;

    const shippingBar = document.querySelector(".free-shipping-bar");

    const threshold = parseInt(shippingBar.dataset.shippingThreshold) * 100;
    const currentTotal = cartData.total_price;
    const remaining = threshold - currentTotal;
    const moneyFormat = shippingBar.dataset.moneyFormat;

    const shippingMessage = document.querySelector(".free-shipping-message");
    const progressBar = document.querySelector(".progress-bar .progress");
    const shippingCostElement = document.querySelector(".shipping-message");

    const afterMessage = shippingBar.dataset.afterMessage;
    const beforeMessage = shippingBar.dataset.beforeMessage;

    const congratulationsMessage = shippingBar.dataset.congratulationsMessage;

    if (remaining > 0) {
      // Update progress message
      if (shippingMessage) {
        shippingMessage.innerHTML = `
        <span>${beforeMessage} ${formatMoney(
          threshold,
          money_without_trailing_zeros_format
        )} </span>
        <span>${formatMoney(
          remaining,
          money_without_trailing_zeros_format
        )} ${afterMessage}</span>`;
      }

      // Update progress bar
      const progressPercent = (currentTotal / threshold) * 100;
      progressBar.style.width = `${Math.min(progressPercent, 100)}%`;

      // Hide free shipping message if visible
      if (shippingCostElement && progressPercent >= 100) {
        shippingCostElement.style.display = "none";
      }
    } else {
      // Show success message
      if (shippingMessage) {
        shippingMessage.innerHTML = `
        <span>${beforeMessage} ${formatMoney(
          threshold,
          money_without_trailing_zeros_format
        )} </span>
        <span class="shipping-achieved">${congratulationsMessage}</span>`;
      }

      // Set progress to 100%
      if (progressBar) {
        progressBar.style.width = "100%";
      }

      // Show free shipping cost
      if (shippingCostElement) {
        shippingCostElement.style.display = "flex";
      }
    }
  }

  async function handleQuickAdd(form) {
    // Prevent multiple simultaneous submissions
    if (isQuickAdding) return;
    isQuickAdding = true;

    // Get form elements
    const submitButton = form.querySelector('[type="submit"]');
    const spinner = form.querySelector(".loading-spinner-quick");
    const buttonText = submitButton?.querySelector(".button-text");
    const originalText = buttonText?.innerHTML || "";

    try {
      // Set loading state
      if (submitButton) {
        submitButton.disabled = true;
        if (buttonText) {
          buttonText.innerHTML = "";
          buttonText.style.opacity = "0";
        }
        if (spinner) {
          spinner.style.display = "block";
        }
      }

      const formData = new FormData(form);
      const variantId = formData.get("id");

      if (!variantId) {
        throw new Error("No variant ID found");
      }

      const response = await fetch(routes.cart_add_url + ".js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        }),
      });

      const data = await response.json();

      if (response.ok) {
        if (
          typeof publish === "function" &&
          typeof PUB_SUB_EVENTS !== "undefined"
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            action: "add",
            variant: data,
            formData: Object.fromEntries(formData),
            product: {}, // You can pass product data here if available
          });
        }

        // Refresh cart content
        await refreshCartContent(data);

        // Open cart drawer if not already open
        const cartDrawer = document.getElementById("cart-drawer");
        if (cartDrawer && !cartDrawer.classList.contains("open")) {
          openCartDrawer();
        }
      } else {
        throw new Error(data.description || "Failed to add to cart");
      }
    } catch (error) {
      console.error("Quick add error:", error);

      // Show error to user
      if (buttonText) {
        buttonText.textContent = "Error - Try Again";
        buttonText.style.opacity = "1";
      }

      if (
        typeof publish === "function" &&
        typeof PUB_SUB_EVENTS !== "undefined"
      ) {
        publish(PUB_SUB_EVENTS.cartError, {
          error: error.message,
          context: "add-to-cart",
        });
      }
    } finally {
      isQuickAdding = false;

      // Reset button state
      if (submitButton) {
        submitButton.disabled = false;
        if (buttonText) {
          buttonText.style.opacity = "1";
          buttonText.innerHTML = originalText;
        }
        if (spinner) {
          spinner.style.display = "none";
        }
      }
    }
  }

  document.querySelectorAll(".featured-slider").forEach(initFeaturedSlider);
  window.initFeaturedSlider = initFeaturedSlider;
});

// Make slider initialization a reusable function
function initFeaturedSlider(slider) {
  const container = slider.parentElement;
  const header = container.closest(
    ".featured-container"
  )?.previousElementSibling;
  const prevBtn = header?.querySelector(".prev");
  const nextBtn = header?.querySelector(".next");
  const items = slider.querySelectorAll(".product-card-item");

  if (!items.length) return;

  // Helper functions
  const getCurrentGap = () =>
    parseInt(window.getComputedStyle(slider).gap) || 10;
  const getCardWidth = () => items[0].offsetWidth + getCurrentGap();

  // Slider state
  let currentPosition = 0;
  let maxPosition = slider.scrollWidth - container.offsetWidth;
  let isDragging = false;
  let startX = 0;
  let startPosition = 0;
  const clickThreshold = 5;

  // Initialize
  updateButtons();

  // 1. PREVENT IMAGE DRAGGING
  slider.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
    img.addEventListener("dragstart", (e) => {
      e.preventDefault();
      return false;
    });
  });

  // 2. NAVIGATION BUTTONS
  if (prevBtn && nextBtn) {
    prevBtn.addEventListener("click", () => {
      currentPosition = Math.min(currentPosition + getCardWidth(), 0);
      slideTo(currentPosition);
    });

    nextBtn.addEventListener("click", () => {
      currentPosition = Math.max(
        currentPosition - getCardWidth(),
        -maxPosition
      );
      slideTo(currentPosition);
    });
  }

  // 3. DRAG HANDLING - MOUSE AND TOUCH
  slider.addEventListener("mousedown", startDrag);
  slider.addEventListener("touchstart", startDrag, { passive: false });

  function startDrag(e) {
    if (e.type === "mousedown" && e.button !== 0) return;

    isDragging = false;
    startX = e.type === "touchstart" ? e.touches[0].clientX : e.clientX;
    startPosition = currentPosition;

    document.addEventListener("mousemove", handleDrag);
    document.addEventListener("touchmove", handleDrag, { passive: false });
    document.addEventListener("mouseup", endDrag);
    document.addEventListener("touchend", endDrag);

    e.preventDefault();
  }

  function handleDrag(e) {
    const currentX = e.type === "touchmove" ? e.touches[0].clientX : e.clientX;
    const diff = startX - currentX;

    if (!isDragging && Math.abs(diff) < clickThreshold) return;

    if (!isDragging) {
      isDragging = true;
      slider.classList.add("dragging");
      document.body.classList.add("slider-dragging");
      slider.style.transition = "none";
    }

    currentPosition = Math.max(Math.min(startPosition - diff, 0), -maxPosition);
    slider.style.transform = `translateX(${currentPosition}px)`;

    e.preventDefault();
  }

  function endDrag(e) {
    document.removeEventListener("mousemove", handleDrag);
    document.removeEventListener("touchmove", handleDrag);
    document.removeEventListener("mouseup", endDrag);
    document.removeEventListener("touchend", endDrag);

    document.body.classList.remove("slider-dragging");

    if (!isDragging) {
      const target = e.target.closest("a");
      if (target) target.click();
      return;
    }

    isDragging = false;
    slider.classList.remove("dragging");

    const cardIndex = Math.round(Math.abs(currentPosition) / getCardWidth());
    currentPosition = -Math.min(cardIndex * getCardWidth(), maxPosition);
    slideTo(currentPosition);
  }

  function slideTo(position) {
    currentPosition = position;
    slider.style.transition = "transform 0.3s ease";
    slider.style.transform = `translateX(${position}px)`;
    updateButtons();
  }

  function updateButtons() {
    if (!prevBtn || !nextBtn) return;
    prevBtn.disabled = currentPosition >= 0;
    nextBtn.disabled = currentPosition <= -maxPosition || maxPosition <= 0;
  }

  // Handle responsive changes
  const resizeObserver = new ResizeObserver(() => {
    maxPosition = slider.scrollWidth - container.offsetWidth;
    currentPosition = Math.max(Math.min(currentPosition, 0), -maxPosition);
    slideTo(currentPosition);
    updateButtons();
  });
  resizeObserver.observe(container);
}
